import { HomeStyles } from './HomeStyles'
import Text from '../../components/text/Text'
import SvgIcon from '../../components/svgIcon/SvgIcon'
import { ToolsComponent } from './components/tools/Tools'
import React, { useEffect, useRef, useState } from 'react'
import { GuidesComponent } from './components/guides/Guides'
import { InvoiceComponent } from './components/invoice/Invoice'
import { AnalysisComponent } from './components/analysis/Analysis'
import { MissionsComponent } from './components/missions/Missions'
import { TransactionsComponent } from './components/transactions/Transactions'
import { useLocation } from 'react-router-dom'
import { getCommerceInfo } from '../../services/commerce'
import TokensProvider from '../../context/tokensContext'
import './Home.css'
import { getLocal, getLocalName } from '../../Utils/Profile'
interface ICommerceInfo {
    nameLocal: string
}
export default function Home() {
    const location = useLocation()

    const divRef = useRef<any>(null)
    const [size, setSize] = useState({ height: 0 })
    const [commerceInfo, setCommerceInfo] = useState<ICommerceInfo>({
        nameLocal: '',
    })

    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)
    const commerceId = user?.sEstablecimiento + getLocal()

    const local = getLocal()
    useEffect(() => {
        getCommerceInfo(commerceId).then((resp) => {
            setCommerceInfo(resp)
        })
    }, [local])

    useEffect(() => {
        if (divRef.current) {
            const updateSize = () => {
                setSize({
                    height: divRef.current?.offsetHeight,
                })
            }

            updateSize()
            window.addEventListener('resize', updateSize)
            return () => window.removeEventListener('resize', updateSize)
        }
    }, [local])
    const renderBanner = () => {
        const queryParams = new URLSearchParams(location.search)

        const hasSubmitedPlan = queryParams.get('plan')
        if (hasSubmitedPlan === 'success')
            return (
                <div style={HomeStyles.section}>
                    <div style={HomeStyles.topTitleContaier}>
                        <div style={HomeStyles.planSuccesContainer}>
                            <Text
                                color="#fff"
                                fontSize={24}
                                fontWeight={700}
                                fontFamily="Poppins"
                                label={`🎉 ¡Felicidades mejoraste tu plan al siguiente nivel! 🎉`}
                            />
                        </div>
                    </div>
                </div>
            )

        return (
            <div style={HomeStyles.section}>
                <div style={HomeStyles.topTitleContaier}>
                    <SvgIcon iconName="IconHola" />
                    <div style={HomeStyles.topTitileTextContianer}>
                        <Text
                            color="#fff"
                            fontSize={20}
                            fontWeight={700}
                            label={`Hola ${getLocalName()}`}
                        />
                        <Text
                            color="#fff"
                            fontSize={20}
                            fontWeight={700}
                            label="¡Demosle un impulso a tu negocio!"
                        />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div style={HomeStyles.container}>
            {renderBanner()}
            <div style={HomeStyles.section}>
                <div style={HomeStyles.gridContent}>
                    <div
                        style={{
                            ...HomeStyles.gridTransactionContent,
                            height: size.height,
                        }}
                    >
                        <TokensProvider>
                            <TransactionsComponent
                                key={`transactions-comp${local}`}
                            />
                        </TokensProvider>
                    </div>
                    <div ref={divRef} style={HomeStyles.gridRightContent}>
                        <div style={HomeStyles.gridRightItemContent}>
                            <InvoiceComponent key={`invoice-comp${local}`} />
                        </div>
                        <div style={HomeStyles.gridRightItemContent}>
                            <AnalysisComponent key={`analyiss-comp${local}`} />
                        </div>
                    </div>
                </div>
            </div>
            <div style={HomeStyles.section}>
                <MissionsComponent key={`missions-comp${local}`} />
            </div>
            <div style={HomeStyles.section}>
                <GuidesComponent key={`guides-comp${local}`} />
            </div>
            <div style={HomeStyles.section}>
                <ToolsComponent key={`tools-comp${local}`} />
            </div>
        </div>
    )
}
